/**
 * 341 (#934): does an UNCONDITIONED grant give `action` on `subject`? 342 moved it here from the backend so the admin
 * panel asks the same question (one definition, Constitution IV).
 *
 * `ability.can(action, 'Subject')` without a record answers for the action type alone, so a supplier's own-organisation
 * grant passes it, and so does everyone's public `read Review`. A permission that means "platform-wide" (a payment's
 * staff view, refunds, review moderation) must ask this instead: a rule with no condition, not cancelled by a later
 * `cannot`. `manage` and `manage all` count (CASL's `rulesFor` includes them).
 */
type Rule = { inverted?: boolean; conditions?: unknown };
/** Any CASL ability (the app's `AppAbility` types its arguments narrowly, hence `never`), or a `{ can }` double. */
interface RulesAbility {
  can(action: never, subject: never): boolean;
  rulesFor?(action: never, subject: never): ReadonlyArray<Rule>;
}

export function holdsAnywhere(ability: RulesAbility, action: string, subject: string): boolean {
  const a = action as never;
  const s = subject as never;
  // Test doubles shaped `{ can }` only: they model a whole role, never a scope.
  if (typeof ability.rulesFor !== 'function') return ability.can(a, s);
  // `rulesFor` lists the most recent rule first; the first unconditioned rule decides, as CASL itself would.
  for (const rule of ability.rulesFor(a, s)) {
    if (rule.conditions) continue;
    return !rule.inverted;
  }
  return false;
}
